import React from 'react';

const defaultValue = () => {}; // executed code so that Jest coverage picks up the file

export default React.createContext(defaultValue);
